import { render, staticRenderFns } from "./HelicopterBaseForm.vue?vue&type=template&id=2a226090&"
import script from "./HelicopterBaseForm.vue?vue&type=script&lang=js&"
export * from "./HelicopterBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports